import size from '../constants/size';
import breakpoints from '../constants/breakpoints';
const isBreakpointBased = param => Object.prototype.toString.apply(param) === '[object Object]';
const isGapRule = rule => rule.toLowerCase().indexOf('gap') > -1;
function generateGridStyles(gridStyles) {
  if (gridStyles) {
    return Object.keys(gridStyles).map(key => {
      const propName = key.split('').map(item => item === item.toUpperCase() ? "-".concat(item.toLowerCase()) : item).join('');
      const styleRule = gridStyles[key];
      if (isBreakpointBased(styleRule)) {
        return Object.keys(styleRule).map(bp => {
          const bpStyleRule = styleRule[bp];
          const useSizes = !!size[bpStyleRule];
          return typeof bpStyleRule !== 'undefined' && bpStyleRule !== null ? "\n            @media (min-width: ".concat(breakpoints[bp], "px) {\n              ").concat(propName, ": ").concat(isGapRule(key) && useSizes && "".concat(size[bpStyleRule], "px") || bpStyleRule, ";\n            }\n          ") : '';
        }).join('');
      }
      if (typeof styleRule !== 'undefined' && styleRule !== null) {
        const useSizes = !!size[gridStyles[key]];
        return "\n          ".concat(propName, ": ").concat(isGapRule(key) && useSizes && "".concat(size[styleRule], "px") || styleRule, ";\n        ");
      }
      return '';
    }).join('');
  }
  return '';
}
export default generateGridStyles;
//# sourceMappingURL=generateGridStyles.js.map